import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/lib/supabase";
import { useSession } from "@/hooks/use-session";

export type NutritionRollRow = {
  date: string;
  kcal_total: number;
  protein_g: number;
  carbs_g: number;
  fat_g: number;
  fiber_g: number;
  meals_logged: number;
};

export function useTodayNutritionRoll() {
  const { session } = useSession();
  const userId = session?.user?.id;

  return useQuery<NutritionRollRow | null>({
    queryKey: ["nutrition_roll", userId, "today"],
    enabled: Boolean(userId),
    staleTime: 60_000,
    queryFn: async () => {
      if (!userId) return null;
      const today = new Date();
      const isoDay = `${today.getFullYear()}-${pad(today.getMonth() + 1)}-${pad(today.getDate())}`;
      const { data, error } = await supabase
        .from("nutrition_roll")
        .select("date, kcal_total, protein_g, carbs_g, fat_g, fiber_g, meals_logged")
        .eq("user_id", userId)
        .eq("date", isoDay)
        .maybeSingle();
      if (error) throw error;
      if (!data) return null;
      return {
        date: data.date,
        kcal_total: Number(data.kcal_total ?? 0),
        protein_g: Number(data.protein_g ?? 0),
        carbs_g: Number(data.carbs_g ?? 0),
        fat_g: Number(data.fat_g ?? 0),
        fiber_g: Number(data.fiber_g ?? 0),
        meals_logged: Number(data.meals_logged ?? 0),
      };
    },
  });
}

function pad(n: number): string {
  return n < 10 ? `0${n}` : `${n}`;
}
